import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceTaxTypeCodeContainerModel } from '../../../../../models/aggregates/e-invoice';


@Injectable({
  providedIn: 'root'
})
export class MyEInvoiceTaxTypeCodeService extends BaseApiTemplateService<MyEInvoiceTaxTypeCodeContainerModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tax-type-codes/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tax-type-codes/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tax-type-codes/backoffice-ep'
    this.httpClient = http;
  }

}
